import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import DrivingLogPage from './drivingLogPage'
import IdleTimeReportPage from './idleTimeReport/idleTimeReportPage'

export const drivingLogsSubPages = {
  main: 'main',
  idleTime: 'idle-time'
}

export const DrivingLogsRouter = () => {
  const location = useLocation()

  const [subPage, setSubPage] = useState(location.pathname.split('/').pop())

  useEffect(() => {
    setSubPage(location.pathname.split('/').pop())
  }, [location])

  return (
    <>
      {subPage === drivingLogsSubPages.main && <DrivingLogPage />}
      {subPage === drivingLogsSubPages.idleTime && <IdleTimeReportPage />}
    </>
  )
}
